var _desc, _defs, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval 3",
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#61AF3D",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/oval.5f838d08243f8ff1344a829992f16879.svg";
export { ForwardRef as ReactComponent };